import { flatten, map, pipe, prop } from 'ramda';
import { StringMap } from '../../../types';
import { Tag, TagAttribute } from '../types';

export const getMetaTags = pipe(map(prop('tags')), flatten);

export const getTranslatedMetaTags = (metaTags: Array<Tag>, t: any): Array<Tag> =>
  metaTags.map(
    (tag: Tag): Tag => ({
      ...tag,
      tagContent: t(tag.tagContent),
      tagAttributes: tag.tagAttributes.map(
        (attr: TagAttribute): TagAttribute => ({
          ...attr,
          value: t(attr.value),
        })
      ),
    })
  );

export const getAttributes = (tag: Tag): StringMap<string> => {
  return tag.tagName === 'meta'
    ? tag.tagAttributes.reduce(getMetaAttributes, {})
    : tag.tagAttributes.reduce(getCommonAttributes, {});
};

/**
 * Returns only one pare of attributes
 * Because meta tag has attributes by follow pattern <meta name="{name}" content="{content}" />
 */
export const getMetaAttributes = (_map: StringMap<string>, attr: TagAttribute): StringMap<string> => ({
  name: attr.name,
  content: attr.value,
});

/**
 * Returns attributes for tags by follow pattern <tagName {name}="{content}" />
 */
export const getCommonAttributes = (map: StringMap<string>, attr: TagAttribute): StringMap<string> => ({
  ...map,
  [attr.name]: attr.value,
});
